import React from 'react'
import { FieldPath, UseFormRegisterReturn } from 'react-hook-form'
import { Radio as BaseRadio } from '@overdose/components'
import classNames from 'classnames'

import styles from './Radio.module.css'
import { RadioProps } from './Radio.types'

export const Radio = <
  TFormValues extends Record<string, unknown> = Record<string, unknown>
>({
  name,
  label = '',
  checked,
  defaultChecked,
  onChange,
  onClick,
  value,
  disabled = false,
  theme = {},
  size = 'md',
  register,
}: RadioProps<TFormValues>) => {
  const { radio, ...rest } = theme
  const useFormProps = register
    ? register(name as FieldPath<TFormValues>)
    : ({} as UseFormRegisterReturn)

  return (
    <BaseRadio
      name={name}
      value={value}
      theme={{
        radio: classNames(styles.radio, radio, {
          [styles.radioActive]: checked && !disabled,
          [styles.disabled]: disabled,
          [styles.checkedAndDisabled]: checked && disabled,
        }),
        ...rest,
      }}
      onClick={onClick}
      checked={checked}
      defaultChecked={defaultChecked}
      size={size}
      disabled={disabled}
      {...useFormProps}
      onChange={(value: string, event: React.ChangeEvent<HTMLInputElement>) => {
        if (useFormProps?.name) {
          useFormProps?.onChange(event)
        }
        return onChange?.(value, event)
      }}>
      {label}
    </BaseRadio>
  )
}
